import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import findIndex from 'ramda/src/findIndex';
import propEq from 'ramda/src/propEq';
import Avatar from '@components/@core/Avatar';
import Button from '@components/@core/AnimatedButton';
import UserCard from '@components/ConnectionCard';
import Input from '@components/@core/Input';
import CompanyActions from '~/actions/company';

const People = ({ company, connections, search, users, onSearch }) => {
    const dispatch = useDispatch();

    const handleConnect = (e) => () => {
        const payload = {
            data: { company_id: company?.id, connect_user_id: e?.id },
            after: { type: 'GETBUSINESS_REQUEST', payload: { id: company.business_id } },
        };
        dispatch(CompanyActions.postcompanyfollowRequest(payload));
        onSearch('');
    };

    return (
        <div className="connections-people">
            <p className="search-label ps-3 dsl-b20 text-500">Search for People</p>
            <Input className="search-input mb-2 ps-2 ps-sm-0" placeholder="Search here..." value={search} onChange={onSearch} />
            {users?.length > 0 && (
                <Row className="mx-2">
                    {users.map((user) => {
                        const idx = findIndex(propEq('id', user.id), connections);
                        if (idx > -1) return null;
                        const userName = `${user?.first_name} ${user?.last_name}`;
                        return (
                            <Col key={user.id} className="p-2" xs={12} sm={6} md={3}>
                                <div className="connection-card">
                                    <div className="card-status" />
                                    <Avatar className="mb-3" url={user?.avatar} name={userName} size="small" isSponsored={true} />
                                    <p className="dsl-b16 bold truncate-two text-center mb-2">{userName}</p>
                                    <p className="dsl-b14 text-400 truncate-two text-center">{user?.profile?.job_title}</p>
                                    <p className="dsl-m12 text-400">{user?.stats ? `${user?.stats.connections} mutual connections` : 'Based on your profile'}</p>
                                    <Button name="Connect" onClick={handleConnect(user)} />
                                </div>
                            </Col>
                        );
                    })}
                </Row>
            )}
            <p className="search-label dsl-b20 text-500 ps-3">Connected</p>
            <Row className="mx-1">
                {connections.map((user) => (
                    <Col key={user.id} className="p-0 p-sm-3 ps-3" xs={12} sm={6} md={3}>
                        <UserCard data={user} tab="people" />
                    </Col>
                ))}
                {connections.length === 0 && <p className="dsl-b16 p-3">No people</p>}
            </Row>
        </div>
    );
};

People.propTypes = {
    connections: PropTypes.array,
    search: PropTypes.string,
    users: PropTypes.array,
    onSearch: PropTypes.func,
};

People.defaultProps = {
    connections: [],
    search: '',
    users: [],
    onSearch: () => {},
};

export default People;
